import App from '@/App'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: App }
]

export default new VueRouter({
  mode: 'history',
  routes
})
